import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner, Dropdown, dateTranslate } from 'yankees-react-utils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useOktaQuery, Game } from '../data';
import useConfig from '../utils/useConfig';

const gameTitle = (translate, { hometeam, awayteam, gamedate }) => `${awayteam} @ ${hometeam}, ${dateTranslate(translate, `${moment(gamedate).format('YYYY-MM-DD')} 12:00:00`)}`;

const queryGames = async (accessToken, playerId, yearId) => {
    const resp = await Game.byplayerstats(accessToken, { playerId, yearId });
    return resp.games.sort((a, b) => (dayjs(a.gamedate).isBefore(b.gamedate) ? 1 : -1));
};

const GameSelector = ({ playerId, yearId, gameid, onSelect }) => {
    const { t: translate } = useTranslation();
    const [year, setYear] = useState({ name: yearId, value: yearId });
    const { data: games, isFetching, refetch } = useOktaQuery(
        ['gamesbyplayerstats', { playerId, yearId: year.value }],
        (accessToken) => queryGames(accessToken, playerId, year.value),
    );
    const { CurrentYear } = useConfig();
    const yearOptions = [CurrentYear, CurrentYear - 1, CurrentYear - 2, CurrentYear - 3, CurrentYear - 4,
        CurrentYear - 5, CurrentYear - 6, CurrentYear - 7, CurrentYear - 8, CurrentYear - 9, CurrentYear - 10].map((y) => ({ name: y, value: y }));

    useEffect(() => {
        refetch();
    }, [year, yearId, refetch]);

    if (isFetching) {
        return <LoadingSpinner />;
    }
    const options = games.map((gm) => ({ name: gameTitle(translate, gm), value: gm.gameid }));
    const value = options.find((g) => g.value === gameid);
    return (
        <>
            <Dropdown options={yearOptions} value={year} onSelect={setYear} />
            &nbsp;
            <Dropdown options={options} value={value} title={translate('common.select-a-game')} onSelect={onSelect} />
        </>
    );
};

GameSelector.propTypes = {
    playerId: PropTypes.number.isRequired,
    yearId: PropTypes.number.isRequired,
    gameid: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
};
GameSelector.defaultProps = {
    gameid: null,
};

export default GameSelector;
